import React from 'react';
import { sumBy } from 'lodash';
import { withStyles } from '@material-ui/styles';
import Tooltip from 'components/tooltips/Tooltip';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  GRAPH_AND_CHART_COLORS,
} from 'themes/colors';

const styles = theme => ({
  grid: {
    display: 'grid',
    rowGap: '.5rem',
    columnGap: '1rem',
    gridTemplateColumns: 'repeat(auto-fit, minmax(10rem, 1fr))',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: '.5rem',
    },
  },
  itemWrapper: {
    padding: '0.5rem',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.secondary['50'],
    },
    '&.active': {
      backgroundColor: theme.palette.secondary['50'],
    },
  },
  itemName: {
    fontSize: '12px',
    color: theme.palette.secondary.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 .5rem',
    flex: '1 2 auto',
  },
  itemPercent: {
    fontSize: '12px',
    color: theme.palette.secondary.text,
  },
  dot: {
    width: '.7rem',
    height: '.7rem',
    borderRadius: '10rem',
    display: 'inline-block',
  },
});


const CategoryGrid = (props) => {
  const {
    classes,
    setActiveIndex,
    dataSource,
    activeIndex,
  } = props;
  const totalSum = sumBy(dataSource, 'value');
  return (
    <div className={classNames({ [classes.grid]: dataSource.length > 4, [classes.column]: dataSource.length <= 4 })}>
      {dataSource.map((item, i) => (
        <div
          className={classNames(classes.itemWrapper, i === { active: activeIndex })}
          onMouseEnter={() => setActiveIndex(i)}
        >
          <span
            className={classes.dot}
            style={{ backgroundColor: GRAPH_AND_CHART_COLORS[i % GRAPH_AND_CHART_COLORS.length] }}
          />
          <Tooltip title={item.name}>
            <div className={classes.itemName}>
              {item.name}
            </div>
          </Tooltip>
          <div className={classes.itemPercent}>{+((item.value / totalSum) * 100).toFixed(2)}%</div>
        </div>
      ))}
    </div>
  );
};

CategoryGrid.propTypes = {
  classes: PropTypes.element.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
  dataSource: PropTypes.shape({}).isRequired,
  activeIndex: PropTypes.number,
};

CategoryGrid.defaultProps = {
  activeIndex: -1,
};

export default withStyles(styles)(CategoryGrid);
